// @flow

import type {
  SoilJobOperationsById,
} from 'hfty-operator-soil-jobs/types'

// Constants
import {
  TREE,
  OPERATIONS_BRANCH,
} from '../constants'

import traverse from 'fc-utils/traverse'

type SoilJobOperationsSelector = (state: Object) => SoilJobOperationsById

export default (traverse([TREE, OPERATIONS_BRANCH]): SoilJobOperationsSelector)
